import React, {memo, ReactNode} from 'react';

import './index.scss';
import {onClickHandler} from '../../utils/onclick';

type Props = {
    hash: string;
    onKeyPress: (key: string) => void;
    specialKeys?: { [key: string]: ReactNode | string };
};

export const NumpadExtended = memo(function NumpadExtended({hash, onKeyPress, specialKeys}: Props) {
    return (
        <div className="keypad-wrapper">
            <div className="keypad">
                <span>{hash}</span>
                <div className="keypad-row">
                    <span {...onClickHandler(() => onKeyPress('1'))}>1</span>
                    <span {...onClickHandler(() => onKeyPress('2'))}>2</span>
                    <span {...onClickHandler(() => onKeyPress('3'))}>3</span>
                </div>
                <div className="keypad-row">
                    <span {...onClickHandler(() => onKeyPress('4'))}>4</span>
                    <span {...onClickHandler(() => onKeyPress('5'))}>5</span>
                    <span {...onClickHandler(() => onKeyPress('6'))}>6</span>
                </div>
                <div className="keypad-row">
                    <span {...onClickHandler(() => onKeyPress('7'))}>7</span>
                    <span {...onClickHandler(() => onKeyPress('8'))}>8</span>
                    <span {...onClickHandler(() => onKeyPress('9'))}>9</span>
                </div>
                <div className="keypad-row">
                    {
                        renderIf(specialKeys?.['*'])(() => (
                            <span {...onClickHandler(() => onKeyPress('*'))}>{specialKeys['*']}</span>
                        ), () => (
                            <span className="no-style"/>
                        ))
                    }
                    <span {...onClickHandler(() => onKeyPress('0'))}>0</span>
                    {
                        renderIf(specialKeys?.['#'])(() => (
                            <span {...onClickHandler(() => onKeyPress('#'))}>{specialKeys['#']}</span>
                        ), () => (
                            <span className="no-style"/>
                        ))
                    }
                </div>
            </div>
        </div>
    );
});
